import React, { useMemo } from 'react';
import styled from 'styled-components';
import { CardTitleWrapper, CardSubtitle, CardTitle, InfoCardStyled, CardBody, /*TRANSITION_LENGTH*/ } from '../../styles/emit-styles/CardStyles';
import Search from './Search';
import ExcelDownloadButton from './ExcelDownloadButton';
import VehicleTable from './VehicleTable';
import { allVehiclesTableColumns, altFuelVehiclesTableColumns } from './TableHelpers';
import { AVOIDED_TABLE_TYPE, GENERATED_TABLE_TYPE } from './HelperConstants';
import { useState } from 'react';
import { vehicleIsAltFuel } from './UtilityFunctions';
// NOTE: Various code is commented out below which supported the display of the emissions ratio header tooltip. Leaving this in as the code may be helpful for implementing future tooltips, and the emissions ratio might be reinstated in the future. -NK

// import { ChartHover } from '../../styles/emit-styles/ChartStyles';

// const EMISSIONS_RATIO_HEADER = 'Emission Ratio';
// const EMISSIONS_RATIO_COPY = 'The emission ratio is the total emissions per mile for each vehicle.';
// const MAX_HOVER_WIDTH = 280;

const Table = styled.div`
    width: 100%;
    height: 100%;
`;

const TableHeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

const TableBodyWrapper = styled.div`
    max-width: 50%;
`;

const ButtonWrapper = styled.div`
    display: flex;
    gap: 16px;
`;

// const TableHeaderHoverContainer = styled(ChartHover)`
//     position: absolute;
//     ${({ cursorCoords }) => `left: ${cursorCoords.x}px; top: ${cursorCoords.y}px`};
//     width: max-content;
//     max-width: 240px;
//     opacity: ${({ visible }) => visible ? 1 : 0};
//     transition: opacity ${TRANSITION_LENGTH} ease;
//     font-size: 14px;
// `;


const TableCard = ({ title, subtitle, description, height, maxHeight, width, tableType, dbDisplayName, beginDate, endDate, selectedVehicleClasses, vehicleClasses, tableData, isTd, methodology, selectedGroups, metricUnitPrefs, macroScale, userSettings }) => {

    const filteredTableData = useMemo(() => {
        return (tableType === AVOIDED_TABLE_TYPE) ? tableData.filter((v) => vehicleIsAltFuel(v)) : tableData;
    }, [tableType, tableData]); // Recalculate only if tableType or tableData changes

    const [matchingData, setMatchingData] = useState(filteredTableData);
    const shorthandUnits = true; // use shorthand units in table headers

    // const [showEmissionRatioToolTip, setShowEmissionRatioToolTip] = useState(false);
    // const [cursorCoords, setCursorCoords] = useState({ x: 0, y: 0 });

    // const handleShowEmissionRatioToolTip = (show, mouseEvent) => {
    //     const windowWidth = window.innerWidth;

    //     let x = mouseEvent.clientX + 20;
    //     let y = mouseEvent.clientY + 20;

    //     if (x + MAX_HOVER_WIDTH > windowWidth) {
    //         x = windowWidth - MAX_HOVER_WIDTH - 40; // Adjust x to keep hover within window
    //     }

    //     setCursorCoords({ x, y });
    //     setShowEmissionRatioToolTip(show);
    // }

    // const allVehiclesTableColumnsWithHovers = allVehiclesTableColumns(isTd, methodology, metricUnitPrefs, macroScale, shorthandUnits);
    // let emissionsRatioHeader = allVehiclesTableColumnsWithHovers.find((vtc) => vtc.Header === EMISSIONS_RATIO_HEADER);
    // if (emissionsRatioHeader) { emissionsRatioHeader.showToolTip = handleShowEmissionRatioToolTip }
    const tableColumns = (tableType === GENERATED_TABLE_TYPE) ? allVehiclesTableColumns(isTd, methodology, metricUnitPrefs, macroScale, shorthandUnits, userSettings) : altFuelVehiclesTableColumns(isTd, methodology, metricUnitPrefs, macroScale, shorthandUnits, userSettings);
    const searchColAccessors = tableColumns.map((col) => col.accessor);

    return (
        <InfoCardStyled
            height={height}
            maxHeight={maxHeight}
            width={width}
            align='start'
            gap='16px'
        >
            <TableHeaderWrapper>
                <TableBodyWrapper>
                    <CardTitleWrapper>
                        <CardTitle data-testid='table-card-title-testid'>{title}</CardTitle>
                        <CardSubtitle data-testid='table-card-subtitle-testid'>{subtitle}</CardSubtitle>
                    </CardTitleWrapper>
                    <CardBody data-testid='table-card-description-testid'>{description}</CardBody>
                </TableBodyWrapper>
                <ButtonWrapper>
                    <Search
                        setMatchingData={setMatchingData}
                        allData={filteredTableData}
                        searchColAccessors={searchColAccessors}
                        accentInsensitive={true}
                    />
                    <ExcelDownloadButton
                        width='118px'
                        label='Download'
                        beginDate={beginDate}
                        endDate={endDate}
                        tableData={matchingData}
                        selectedGroups={selectedGroups}
                        selectedVehicleClasses={selectedVehicleClasses}
                        vehicleClasses={vehicleClasses}
                        dbDisplayName={dbDisplayName}
                        downloadType={tableType}
                        methodology={methodology}
                        cols={tableColumns}
                        metricUnitPrefs={metricUnitPrefs}
                        macroScale={macroScale}
                        userSettings={userSettings}
                        disabled={matchingData.length < 1}
                    />
                </ButtonWrapper>
            </TableHeaderWrapper>
            {/* <span style={{ position: 'fixed', top: 0, left: 0, zIndex: 3 }}>
                <TableHeaderHoverContainer
                    id={`emissions-ratio-tooltip`}
                    cursorCoords={cursorCoords}
                    visible={showEmissionRatioToolTip}
                >
                    {EMISSIONS_RATIO_COPY}
                </TableHeaderHoverContainer>
            </span> */}
            <Table>
                <VehicleTable
                    columns={tableColumns}
                    data={matchingData}
                    metricUnitPrefs={metricUnitPrefs}
                    macroScale={macroScale}
                    userSettings={userSettings}
                />
            </Table>
        </InfoCardStyled>
    );
};

export default TableCard;